/**
 * Google Analytics 4 (GA4) Tracking Utilities
 * Measurement ID: G-N86VHP08JV
 */

const GA_MEASUREMENT_ID = 'G-N86VHP08JV';

// Extend window type for gtag
declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

/**
 * Track a virtual page view in GA4
 * Used for SPA navigation since React handles routing client-side
 */
function trackPageView(pagePath: string, pageTitle?: string): void {
  if (typeof window !== 'undefined' && window.gtag) {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: pagePath,
      page_title: pageTitle || pagePath,
    });
  }
}

/**
 * Screen name to readable title mapping
 */
const SCREEN_TITLES: Record<string, string> = {
  auth: 'Sign In',
  'parent-dashboard': 'Parent Dashboard',
  'admin-dashboard': 'Admin Dashboard',
  'topic-selection': 'Topic Selection',
  practice: 'Practicing',
  leaderboard: 'Leaderboard',
  statistics: 'Statistics',
  settings: 'Settings',
  'pwa-test': 'PWA Test',
  about: 'About',
};

/**
 * Track screen navigation with readable titles
 */
export function trackScreenView(screenName: string): void {
  const title = SCREEN_TITLES[screenName] || screenName;
  trackPageView(`/${screenName}`, `MathXY - ${title}`);
}
